import React from "react";
import { Table } from "antd";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { setActiveStep } from "../../../../../redux/slices/loginSlice";
import { useDispatch, useSelector } from "react-redux";
import addIcon from "../../../../../assets/images/DeathModuleNew/addIcon.png";
import NewLoader from "../../../../../components/styled-components/loader/NewLoader";
import { ToolTipCreator } from "../../../../../helpers/ToolTipCreator";

export const DivorceInsuranceCard = ({
  dataList,
  moduleData,
  loading,
  step,
}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const cols_insurance = [
    {
      title: "Policy Name",
      dataIndex: "Nickname",
      key: "Nickname",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Policy Start Date",
      dataIndex: "Policy Start Date",
      key: "Policy Start Date",
      render: (record) =>
        record ? moment(record).format("DD-MM-YYYY") : "N/A",
    },
    {
      title: "Policy End Date",
      dataIndex: "Policy End Date",
      key: "Policy End Date",
      render: (record) =>
        record ? moment(record).format("DD-MM-YYYY") : "N/A",
    },
    {
      title: "Insurance Company",
      dataIndex: "Carrier",
      key: "Carrier",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Policy Number",
      dataIndex: "Policy Number",
      key: "Policy Number",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Year Premium",
      dataIndex: "year_premium",
      key: "year_premium",
      render: (record) => (record ? record : "N/A"),
    },
  ];
  return (
    <div style={{position:"relative"}}>
      <div className="cardHeadingDisability">
      <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
     {moduleData.Icon && <img width={66} height={56} src={moduleData.Icon} alt={moduleData.name}></img>}
     <div style={{ display: "flex", alignItems: "baseline", columnGap: "3px" }}>
        {moduleData.name}
        {moduleData &&
            moduleData.tooltip &&
            ["Insurance Coverage"].includes(moduleData.name) && (
              <ToolTipCreator name={moduleData.tooltip} />
          )}
     </div>
        </div>
        <div className="uploadButtonsDisability">
          {" "}
          <div
            className="upload"
            style={{ width: "20px", height: "20px" }}
            onClick={() => {
              dispatch(setActiveStep(step));
              history.push("/protector/divorce");
            }}
          >
            <img
              src={addIcon}
              width={12}
              height={12}
              style={{ width: "12px", height: "12px" }}
              alt="addicon"
            ></img>
          </div>
        </div>
      </div>
      <Table columns={cols_insurance} dataSource={dataList} />
      <NewLoader isLoading={loading}/>
    </div>
  );
};
